
<template>
  <!--财务明细-->
  <div class="finance">
    <div class="statist">
      <div class="body-box">
        <div class="body">
          <span class="title">总收入:</span>
          <span class="income">{{financeStatist.income_total_fee}}</span>
        </div>

        <div class="body">
          <span class="title">总支出:</span>
          <span class="pay">{{financeStatist.expense_total_fee}}</span>
        </div>

        <div class="body">
          <span class="title">实际收入:</span>
          <span class="real">{{financeStatist.real_income_total_fee}}</span>
        </div>
      </div>
      <a-button @click="updateAll" type="primary" icon="sync" :loading="btnLoading.loading">刷新</a-button>

    </div>

    <a-tabs class="tabs" type="card" @change="tabsChange" v-model="activeKey">
      <a-tab-pane v-for="(item) of tabList" :key="item.key" :tab="item.title">
        <x-tabula
          apiOrigin="PHP"
          v-if="activeKey === item.key"
          ref="table"
          :excludeResetKey="['finance_type']"
          :dataSource="dataSource"
          rowKey="id"
          :searchList="searchList"
          :columns="columns"
          :tableOptList="tableOptList"
          :rowOptList="rowOptList"
          :searchParams.sync="searchParams"
          :listApi="listApi"
          :addHandleParam="addHandleParam"
          :deleteParam="deleteParam"
          :rowSelection="false"
        >
          <template slot="opt_o" slot-scope="{row}">
            <span v-if="row.finance_type === 2" :style="{fontWeight: 600}" class="success">{{row.total_fee}}</span>
            <span v-else :style="{fontWeight: 600}" class="danger">{{row.total_fee}}</span>
          </template>
        </x-tabula>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'finance',
  data () {
    let payTypeSelect = [
      { label: '微信', value: 1 },
      { label: '支付宝', value: 2 }
    ];
    return {
      financeStatist: {},
      btnLoading: {loading: false},
      activeKey: '',
      tabList: [
        { title: '全部', key: '' },
        { title: '收入', key: 1 },
        { title: '支出', key: 2 }
      ],
      searchList: [
        { props: ['keywords'], placeholder: '订单号、标题、手机号', options: [], inputType: 'input' },
        { props: ['pay_type'], placeholder: '支付方式', options: payTypeSelect, inputType: 'select' },
        { props: ['create_time'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '详情', handle: row => this.toOrderDetail(row), permi: ['community:finance:detail'] }
      ],
      columns: [
        { title: '订单号', dataIndex: 'order_id', align: 'left', width: '' },
        { title: '订单标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '金额(￥)', dataIndex: 'total_fee', align: 'right', width: '', scopedSlots: {customRender: 'o'} },
        { title: '手机号', dataIndex: 'mobile_phone', align: 'left', width: '' },
        { title: '下单时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '付款/退款时间', dataIndex: 'finance_time', align: 'left', width: '' },
        { title: '付款方式', dataIndex: 'pay_type_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined,
        pay_type: undefined,
        create_time: undefined,
        finance_type: undefined
      },
      listApi: {
        url: '/screen_show/finance_log',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.getStatist();
  },
  methods: {
    /** tabs change */
    tabsChange (e) {
      let titleObj = {
        '': '付款/退款时间',
        1: '付款时间',
        2: '退款时间'
      };
      this.columns[5].title = titleObj[e];

      this.resetData(this.searchParams, ['finance_type']);
      Object.assign(this.$refs.table[0].paginationParam, { current: 1, pageSize: 10 });
      this.searchParams.finance_type = e;
    },
    /** 进入对应不同的详情页面 */
    toOrderDetail (row) {
      let orderType = {
        1: 'service', // 有退款
        2: 'pass' // 没有退款
      };
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.order_id,
          type: orderType[row.is_refund],
          ...this.breadParam(this)
        }
      });
    },
    /** 刷新整个页面 */
    updateAll () {
      this.$refs.table[0].getTableList();
      this.getStatist();
    },
    /** 获取财务统计 */
    getStatist () {
      this._get({
        url: '/screen_show/finance_log_statist',
        params: {},
        btnLoading: this.btnLoading
      }).then(({data}) => {
        Object.keys(data).forEach((el) => {
          data[el] = `￥${data[el].toFixed(2)}`;
        });
        this.financeStatist = data;
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss">
/** 财务明细统计 */
.finance {
  .statist {
    margin-bottom: 24px;
    padding: 20px 60px 20px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    .body-box {
      display: flex;
    }
    .body {
      margin-right: 8%;
      min-width: 200px;
      font-size: 22px;
      color: #333;
      .income {
        color: #FF0000;
      }
      .pay {
        color: #009900;
      }
      .real {
        color: #FF6600;
      }
    }
  }
  .tabs {
    padding: 24px;
    background-color: #fff;
  }
}
</style>
